import { hasSlotContent as e } from "../../common/utils/index.js";
import { t } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import n from "../chip/chip.js";
import { createCommentVNode as r, createElementBlock as i, createSlots as a, createVNode as o, openBlock as s, renderSlot as c, resolveComponent as l, withCtx as u } from "vue";
//#region recipes/chips/grouped_chip/grouped_chip.vue
var d = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeGroupedChip",
	components: { DtChip: n },
	data() {
		return { hasSlotContent: e };
	}
}, f = {
	"data-qa": "dt-recipe-grouped-chip",
	class: "d-recipe-grouped-chip"
}, p = {
	key: 0,
	"data-qa": "left-grouped-chip-icon"
}, m = {
	key: 0,
	"data-qa": "left-grouped-chip-content"
}, h = {
	key: 0,
	"data-qa": "right-grouped-chip-icon"
}, g = {
	key: 0,
	"data-qa": "right-grouped-chip-content"
};
function _(e, t, n, d, _, v) {
	let y = l("dt-chip");
	return s(), i("div", f, [o(y, {
		"hide-close": !0,
		interactive: !1,
		size: "xs",
		"grouped-chip": !0,
		class: "d-recipe-grouped-chip__content d-recipe-grouped-chip__content-left"
	}, a({
		default: u(() => [_.hasSlotContent(e.$slots.leftContent) ? (s(), i("div", m, [c(e.$slots, "leftContent")])) : r("", !0)]),
		_: 2
	}, [_.hasSlotContent(e.$slots.leftIcon) ? {
		name: "icon",
		fn: u(() => [_.hasSlotContent(e.$slots.leftIcon) ? (s(), i("div", p, [c(e.$slots, "leftIcon")])) : r("", !0)]),
		key: "0"
	} : void 0]), 1024), o(y, {
		"hide-close": !0,
		interactive: !1,
		size: "xs",
		"grouped-chip": !0,
		class: "d-recipe-grouped-chip__content d-recipe-grouped-chip__content-right"
	}, {
		icon: u(() => [_.hasSlotContent(e.$slots.rightIcon) ? (s(), i("div", h, [c(e.$slots, "rightIcon")])) : r("", !0)]),
		default: u(() => [_.hasSlotContent(e.$slots.rightContent) ? (s(), i("div", g, [c(e.$slots, "rightContent")])) : r("", !0)]),
		_: 3
	})]);
}
var v = /* @__PURE__ */ t(d, [["render", _]]);
//#endregion
export { v as default };

//# sourceMappingURL=grouped-chip.js.map